<template>
  <li
    :key="menu.id"
    :class="{ [$style.parent]: true, [$style.leftBorder]: menu.id === 135 }"
  >
    <b-link
      :to="getRoutes(menu.id)"
      :class="hasChildren && !menu.parentId ? 'dropdown-toggle' : ''"
    >
      {{ menu.apiScopeName }}
      <span
        v-if="hasChildren && menu.parentId"
        :class="$style.expand"
        class="dropdown-toggle float-right"
      >
      </span>
    </b-link>

    <ul
      v-if="hasChildren"
      :class="[
        $style.child,
        menuLevel === 1 ? $style.subMenuParent : $style.subchild,
      ]"
      class="dropdown-menu py-0 dropright"
    >
      <template v-for="data in createSubMenu">
        <RootMenu
          :key="data.id"
          :menu="data"
          :json-data="jsonData"
          :menu-level="menuLevel + 1"
        ></RootMenu>
      </template>
    </ul>
  </li>
</template>

<script>
import constant from '@constants/navbarRoutes'
export default {
  name: 'RootMenu',
  props: {
    menu: {
      type: Object,
      default: () => {},
    },
    jsonData: {
      type: Array,
      default: () => [],
    },
    menuLevel: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      routing: constant.navRoutes,
    }
  },
  computed: {
    hasChildren() {
      return this.jsonData.filter((x) => x.parentId === this.menu.id).length > 0
    },
    createSubMenu() {
      return this.jsonData.filter((x) => x.parentId === this.menu.id)
    },
  },
  methods: {
    getRoutes(id) {
      let route = this.routing.find((x) => x.id === id)
        ? this.routing.find((x) => x.id === id).route
        : null

      switch (id) {
        case 168:
          return `${route}/${
            this.$store.state.auth.currentUser.userInfo.customerId
          }`
        default:
          return route
      }
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';
.parent {
  position: relative;
  display: inline-block;
  float: left;
  padding: 0;
  font-weight: normal;
  list-style-type: none;
}

.leftBorder {
  padding-left: 0.5rem;
  margin-left: 0.8rem;
  border-left: 1px solid #999797;
}

.parent a:hover,
.parent a {
  display: block;
  margin: 12px 18px;
  font-weight: normal;
  color: #fff;
  text-decoration: none;
}
.parent:hover > ul {
  position: absolute;
  top: 40px;
  left: 0;
  display: block;
  background-color: #fff;
}
.parent:hover > ul.subchild {
  position: absolute;
  top: 0;
  left: 99%;
}

.child {
  z-index: 99;
  display: none;
}
.child li {
  width: 100%;
  min-width: 200px;
  line-height: 15px;
}
.child li:hover {
  background: #eaeaea;
}
.child li a {
  color: #000;
  text-decoration: none;
  white-space: nowrap;
}
.child li a:hover {
  color: #000;
}
.child,
.subMenuParent {
  border-radius: 0;
}
.subMenuParent > li {
  opacity: 0.8;
}
.subMenuParent > li:hover {
  border-radius: 0;
  opacity: 1;
}
.subMenuParent > li > ul {
  top: 0 !important;
  left: 100%;
}
.dropWhite a span {
  color: #fff !important;
}
</style>
